import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import "./Testimonials.css";
import API_BASE_URL from "../../config"; // Import your API base URL
import QuoteIcon from "../../assets/quote-icon.png";
import arrow from "../../assets/Arrow.png";

import { motion } from "framer-motion";
// Optional placeholder images or use a default image if no image_url provided
const defaultUserImage = "../../assets/default-user.svg";
const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    // Replace with your actual backend URL
    axios
      .get(`${API_BASE_URL}/testimonials`)
      .then((res) => {
        console.log("testimonials", res);
        setTestimonials(res.data || []);
      })
      .catch((err) => {
        console.error("Failed to fetch testimonials:", err);
      });
  }, []);

  const scrollRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  // const onMouseDown = (e) => {
  //   setIsDragging(true);
  //   setStartX(e.pageX - scrollRef.current.offsetLeft);
  //   setScrollLeft(scrollRef.current.scrollLeft);
  // };

  // const onMouseLeave = () => setIsDragging(false);
  // const onMouseUp = () => setIsDragging(false);
  const onMouseDown = (e) => {
    setIsDragging(true);
    scrollRef.current.classList.add("dragging"); // add class
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
  };

  const onMouseLeave = () => {
    setIsDragging(false);
    scrollRef.current.classList.remove("dragging");
  };

  const onMouseUp = () => {
    setIsDragging(false);
    scrollRef.current.classList.remove("dragging");
  };

  const onMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2; // scroll-fast multiplier
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <section className="testimonials-section">
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        {/* Counts */}
        <div className="counts-row">
          <div className="count-box">
            <h2>
              Experience<span className="dot">.</span>
            </h2>
            <p className="count-number">8+</p>
          </div>
          <div className="count-box">
            <h2>
              Projects<span className="dot">.</span>
            </h2>
            <p className="count-number">100+</p>
          </div>
          <div className="count-box">
            <h2>
              Wins<span className="dot">.</span>
            </h2>
            <p className="count-number">4.9/5</p>
          </div>
        </div>
      </motion.div>

      <div className="fancy-text-div">
        <p className="fancy-text"> your project's in safe hands </p>
      </div>

      <div className="fancy-arrow-div">
        <img src={arrow} className="fancy-arrow" alt="arrow" />
      </div>
      <h3 className="testimonial-heading">Hear It From Our Clients </h3>

      <div
        className="testimonial-scroll-wrapper"
        ref={scrollRef}
        onMouseDown={onMouseDown}
        onMouseLeave={onMouseLeave}
        onMouseUp={onMouseUp}
        onMouseMove={onMouseMove}
      >
        <div className="testimonial-scroll-track">
          {testimonials.concat(testimonials).map((t, idx) => (
            <div className="testimonial-card" key={idx}>
              <img src={QuoteIcon} alt="quote" className="quote-icon" />
              <div className="testimonial-text-div">
                <p className="testimonial-text">"{t.text}"</p>
              </div>
              <hr />
              <div className="testimonial-user">
                <img
                  src={t.image_url || defaultUserImage}
                  alt={t.name}
                  className="user-image"
                />
                <div>
                  <p className="user-name">{t.name}</p>
                  <p className="user-name" style={{ color: "grey" }}>
                    {t.country}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
